import React, { Component } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const FooterSection = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const matrimonyPaths = [
		"/dashboard",
		"/bat-matrimony",
		"/register",
		"/login",
	];

	let isMatrimony = false;
	if (matrimonyPaths.includes(location.pathname)) {
		isMatrimony = true;
	}
	return (
		<footer className="footer-section">
			<div className="footer-top">
				<div className="container">
					<div className="row g-3 justify-content-center g-lg-0 footer-container">
						<div className="col-lg-4 col-sm-6 col-12">
							<div className="footer-wrapper footer-left">
								<div className="footer-header">Contact Details</div>
								<div className="contact-details">
									<div className="details">
										<div className="footer-icon">
											<img
												src="../../assets/images/bat-img/footer-location.svg"
												alt="location icon"
											/>
										</div>
										<div className="footer-content">
											Dallas, Texas United States of America
										</div>
									</div>
									<div className="details">
										<div className="footer-icon">
											<img
												src="../../assets/images/bat-img/footer-mail.svg"
												alt="mail icon"
											/>
										</div>
										<div className="footer-content">support@batus.org</div>
									</div>
									<div className="details">
										<div className="footer-icon">
											<img
												src="../../assets/images/bat-img/footer-caller.svg"
												alt="caller icon"
											/>
										</div>
										<div className="footer-content">+1 707 564 6228</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-sm-6 col-12">
							<div className="footer-top-item lab-item">
								<div className="footer-title">Join us today!</div>
							</div>
						</div>
						<div className="col-lg-4 col-sm-6 col-12">
							<div className="footer-wrapper footer-right">
								<div className="footer-header">Contact Us</div>
								<div className="footer-wrapper">
									We'd love to hear from you! Whether you have a question,
									feedback, or need assistance, feel free to reach out to us.
								</div>
								<div className="footer-email-container">
									<button
										className="button login-btn create-btn text-white text-center pl-30 pr-30"
										onClick={() => navigate("/contact-us")}
									>
										Send Message
									</button>
									{/* <div className="input-field">
                    <input
                      type="email"
                      name=""
                      id=""
                      placeholder="Email Address"
                    />
                  </div>
                  <button className="send-button">
                    <img
                      src="../../assets/images/bat-img/footer-email-sender.svg"
                      alt="send icon"
                    />
                  </button> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="footer-bottom">
				<div className="container">
					<div className="footer-bottom">
						<div className="row g-3 justify-content-center g-lg-0 footer-container">
							<div className="col-lg-4 col-sm-6 col-12">
								<div className="copy-rights mb-20">
									@{new Date().getFullYear()} BAT All rights reserved.
								</div>
								{isMatrimony ? (
									<p>
										This website is strictly for matrimonial purpose only and
										not a dating website.
									</p>
								) : null}
							</div>
							<div className="col-lg-4 col-sm-6 col-12">
								{/* <div className="social-media">
                  <div className="social facebook">
                    <img
                      src="../../assets/images/bat-img/social-facebook.svg"
                      alt="facebook icon"
                    />
                  </div>
                  <div className="social x">
                    <img
                      src="../../assets/images/bat-img/social-x.svg"
                      alt="x icon"
                    />
                  </div>
                  <div className="social youtube">
                    <img
                      src="../../assets/images/bat-img/social-youtube.svg"
                      alt="youtube icon"
                    />
                  </div>
                </div> */}
							</div>
							<div className="col-lg-4 col-sm-6 col-12">
								<div className="terms-and-conditions mb-20">
									Privacy Policy Terms and Conditions
								</div>

							</div>
							<div className="footer-contribution">
								batus.org developed through a charitable contribution of Mr. Kumar Rayasam
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default FooterSection;
